module.exports = __webpack_public_path__ + "img/depmap_svg_V132.c13bc650.svg";